export default __webpack_public_path__ + "static/media/artistBanner2.b58a6a20.png";